import React, { useState, useEffect } from "react";
import { Text, Flex, Box, useBreakpointValue} from "@chakra-ui/react";
import { strings } from "../../localization";
import { IconWarningRegular, IconCloseRegular } from "@telefonica/mistica";


const BrandChangeNotification = (): React.ReactElement => {
	const [show, setShow] = useState(true);
	const {description, title } = strings.components.brandChangeNotification;

	const onClose = (): void => {
		setShow(false);
	};

	useEffect(() => {
		setShow(true);
		const timer = setTimeout(() => {
			setShow(false);
		}, 50 * 1000 );

		return () => clearTimeout(timer);
	}, []);

	const iconCloseRegularSize = useBreakpointValue({base: "24px", lg: "20px"});

	return (
		<Flex
			top={{base: "81px", lg:"105px"}}
			position={"absolute"}
			flexDir={"row"}
			justifyContent={"center"}
			zIndex={5}
			width={"100%"}
		>
			{show &&
      <Flex  maxW={"784px"} w={{base: "95%", lg: "70%"}} backgroundColor={"white"} justifyContent={"center"} borderRadius={"8px"}>
      	<Box mb={"45px"} mt={"16px"} ml={"16px"}>
      		<IconWarningRegular size={"24px"} color={"#660099"}/>
      	</Box>
      	<Flex
      		display={"flex"}
      		flexDir={"column"}
      		margin={"16px 46px 16px 16px"}
      		gap="4px"
      	>
      		<Text fontWeight={400} fontSize={{base: "16px", lg: "18px"}} lineHeight={"24px"} color={"black"}>{title}</Text>
      		<Text fontWeight={400} fontSize={{base: "14px", lg: "16px"}} lineHeight={{base: "20px", lg: "24px"}} color={"gray.600"} mt={{base: "0px", lg: "4px"}}>{description}</Text>
      	</Flex>
      	<Box onClick={onClose} fontSize={"20px"} mb={"46px"} mt={"18px"} mr={"14px"} cursor="pointer" >
      		<IconCloseRegular size={iconCloseRegularSize} color={"black.500"}/>
      	</Box>
      </Flex>
			}
		</Flex>
	);
};

export default BrandChangeNotification;
